import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { CookiesProvider } from 'react-cookie';

import Phi from './Phi/Phi';
import Constants from './Phi/Constants';
import configureStore  from './Store/Store';
import history from './history';
import Routes from './routes';


import './index.css';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import "font-awesome/css/font-awesome.min.css";


initialSetup();



const store = configureStore();

Phi.initialize({ apiPort: Constants.apiPort, apiUrl: Constants.apiHost, apiProtocol: Constants.apiProtocol });

ReactDOM.render(
    <Provider store={store}>
        <CookiesProvider>
            <Router history={history}>
                <Routes />
            </Router>
        </CookiesProvider>
    </Provider>,
    document.getElementById('root'));




// Initialization function

function initialSetup() {

    // Add polyfill for Array.find()
    if(!Array.prototype.find) {
        Array.prototype.find = function(testFn) {
            for(var i=0 ; i < this.length ; i++) {
                if(testFn(this[i], i)) return this[i];
            }

            return undefined;
        }
    }

}